export const CardOne = {
  playListName: "Sports",
  imgUrl: "https://pbs.twimg.com/media/DhocG07X4AEsDx1?format=jpg&name=small",
  // "https://www.deccanherald.com/sites/dh/files/styles/article_detail/public/article_images/2017/11/25/644725.jpg?itok=o9s1ffWI",
  // imgUrl: require("").default,
  link: "leomessi.com",
};

export const CardTwo = {
  playListName: "Gaming",
  imgUrl:
    "https://cdn1.dotesports.com/wp-content/uploads/2019/04/06150427/s1mplestar-1024x683.jpg",

  // imgUrl: require("").default,
  link: "simple.com",
};

export const CardThree = {
  playListName: "Coding",
  imgUrl:
    "https://www.parkersoftware.com/wp-content/uploads/2020/10/pankaj-patel-_SgRNwAVNKw-unsplash-1024x683.jpg",

  // imgUrl: require("").default,
  link: "facebook.com",
};

export const CardHome = [
  {
    playListName: "Astronomy",
    imgUrl:
      "https://cdn.britannica.com/06/202006-050-64C85CC7/Neil-deGrasse-Tyson-2018.jpg",
    link: "abhi",
  },
  {
    playListName: "Medicine",
    imgUrl:
      "https://www.nme.com/wp-content/uploads/2020/04/Doctor-Strange-2-696x441.jpg",
    link: "ram.com",
  },
  {
    playListName: "History",
    imgUrl:
      "https://i.tribune.com.pk/media/images/Hrithik-roshan1613469694-0/Hrithik-roshan1613469694-0.png",
    link: "satpute.com",
  },
];

// [{"url": "https://github.com/abhiram11/Whatsapp-Clone-2-MERN-Pusher",
// "title": "Whatsapp-Clone-2-MERN-Pusher", "tags": "", "deploy": "", "youtube": ""},

//  {"url": "https://github.com/abhiram11/abhiram11",
//   "title": "abhiram11", "tags": "", "deploy": "", "youtube": ""},

//    {"url": "https://github.com/abhiram11/Whatsapp-Clone-ReactJs-MongoDB-SocketIO-NodeJS",
//    "title": "Whatsapp-Clone-ReactJs-MongoDB-SocketIO-NodeJS", "tags": "", "deploy": "", "youtube": ""}

//     {"url": "https://github.com/abhiram11/tiktok-clone-reactnative",
//     "title": "tiktok-clone-reactnative", "tags": "", "deploy": "", "youtube": ""},
export const CardTodayData = [
  {
    title: "Get into coding!",
    description: "Coding is fun",
    imgUrl:
      "https://static.independent.co.uk/2021/08/16/06/GettyImages-1229892421-2.jpg?width=990&auto=webp&quality=75",
  },
  {
    title: "eSports is future!",
    description: "Get to gaming during this pandemic",
    imgUrl:
      "https://www.nme.com/wp-content/uploads/2020/06/060220-Valorant-Riot-Games-1068x678.jpeg",
  },

  {
    title: "Food ?",
    description: "Everything's incomplete without Food!",
    imgUrl:
      "https://i.pinimg.com/564x/6f/90/24/6f902443313b415ce99c6fb4831906ea.jpg",
  },
  {
    title: "Here's Me",
    description: "I do coding and stuff",
    imgUrl: require("../images/me.jpg").default,
  },
];
